import { render, staticRenderFns } from "./ObjectName.vue?vue&type=template&id=127bcd88&scoped=true&"
import script from "./ObjectName.vue?vue&type=script&lang=js&"
export * from "./ObjectName.vue?vue&type=script&lang=js&"
import style0 from "./ObjectName.vue?vue&type=style&index=0&id=127bcd88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127bcd88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VMenu})
